export const yeuCauSuaChua = {
  sections: {
    list: { title: '维修请求' },
    listHang: { title: '维修请求' },
    detail: { title: '维修请求详情' },
    payment: { title: '付款信息' },
    services: { title: '维修与更换服务' },
  },
  aria: {
    columnPicker: '选择显示列',
  },
  titles: { add: '新建请求', edit: '编辑请求' },
  tabs: {
    giaoDich: '交易',
    hangSuaChua: '明细',
    info: '信息',
    services: '维修服务',
    baoCao: '报表',
  },
  columns: {
    code: '编号',
    summary: '信息',
    status: '状态',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    maYeuCau: '请求编号',
    thoiGian: '时间',
    khachHang: '客户',
    khachCanTra: '客户应付',
    khachDaTra: '客户已付',
    maHang: '货品编号',
    tenHang: '货品名称',
    serialImei: 'Serial / IMEI',
    loaiYeuCau: '请求类型',
    trangThaiSuaChua: '维修状态',
    ngayHenTraKhach: '预约归还',
    ngayHoanThanh: '完成日期',
    tongPhi: '总费用',
    ghiChuHang: '货品备注',
    donGia: '单价',
    giamGia: '优惠',
    giaBan: '售价',
    thanhTien: '金额',
    nguoiNhan: '接收人',
    noiTiepNhan: '接收地点',
    bangGia: '价格表',
    chiNhanh: '门店',
    soLuong: '数量',
    ghiChu: '备注',
    note: '备注',
    maHoaDon: '发票编号',
    maPhieuXuatKho: '出库单号',
    ngayNhan: '接收日期',
    ngayTra: '归还日期',
    nguoiNhanTra: '领回人',
    noiDungBaoLoi: '报修内容',
    ngayBaoLoi: '报修日期',
    ngayLenHoaDonLinhKien: '配件开票日期',
    ngayCoLinhKien: '配件到货日期',
    tinhTrangTra: '归还状态',
    ketQuaChotKhach: '客户确认结果',
    lyDoKetThuc: '结束原因',
    ngayTraTongHop: '归还日期 (已全部归还)',
    ngayTraTongHopHint: '全部设备归还后自动计算 — 取最后一次归还的日期与领回人。',
    ngayLap: '开单日期',
    model: '型号',
    ngayChotKhach: '客户确认日期',
    ghiChuSuaChua: '维修备注',
  },
  status: {
    dangXuLy: '处理中',
    hoanThanh: '已完成',
    daHuy: '已取消',
  },
  trangThai: {
    dangXuLy: '处理中',
    hoanThanh: '已完成',
    daHuy: '已取消',
  },
  trangThaiSuaChua: {
    daNhan: '已接收',
    dangXuLy: '处理中',
    sanSangTraKhach: '可归还',
    hoanThanh: '已完成',
  },
  loaiYeuCau: {
    suaChuaDichVu: '维修服务',
    yeuCauBaoHanhSP: '产品保修申请',
    baoHanhDinhKy: '定期保养',
  },
  ketQuaChotKhach: {
    chuaChot: '待确认',
    dongYSua: '同意维修',
    khongSua: '不维修',
  },
  lyDoKetThuc: {
    suaXong: '维修完成',
    khachKhongSua: '客户不维修',
    khongCoLinhKien: '缺少配件',
    khongThayLoi: '未发现故障',
  },
  filter: {
    searchPlaceholder: '按请求编号搜索',
    textDetailTitle: '高级筛选',
  },
  filters: {
    maKhachHang: '客户编码',
    tenKhachHang: '客户名称',
    hintSection: '提示',
    hintBody: '切换标签查看不同列表。',
    statusAll: '全部',
    maHang: '货品编号',
    tenHang: '货品名称',
    sectionStatus: '状态',
    sectionStatusSC: '维修状态',
    sectionType: '请求类型',
    sectionTime: '创建时间',
    sectionTimeBaoCao: '时间',
    sectionUpdatedTime: '更新时间',
    sectionReturnDate: '归还日期',
    sectionCompletedDate: '完成日期',
    sectionTrangThaiTra: '归还状态',
    sectionKetQuaChot: '客户确认结果',
    sectionLyDoKetThuc: '结束原因',
    sectionGiaiDoan: '处理阶段',
    sectionKyThuatVien: '技师',
    kyThuatVienAll: '全部',
    chuaPhanCong: '未分配',
    daTra: '已归还',
    chuaTra: '未归还',
    dateRangePlaceholder: '选择日期范围',
    from: '从',
    to: '至',
    allTime: '全部时间',
  },
  form: {
    code: '请求编号',
    codeAuto: '留空自动生成',
    customer: '客户',
    receiver: '接收人',
    creator: '创建人',
    createdAt: '创建时间',
    receivePlace: '接收地点',
    noiTiepNhanCuaHang: '到店',
    noiTiepNhanTaiNha: '上门',
    noiTiepNhanKhac: '其他',
    datShip: '第三方物流',
    deliveryPartner: '物流合作方',
    serviceType: '服务类型',
    maVanDon: '运单号',
    receiverName: '收件人',
    receiverPhone: '电话',
    deliveryAddress: '收货地址',
    deliveryFee: '运费',
    priceList: '价格表',
    note: '备注',
    lines: '维修货品',
    addLine: '新增行',
    product: '货品',
    productSearch: '搜索编号/名称',
    requestType: '请求类型',
    typeRepair: '维修服务',
    typeWarranty: '保修',
    serial: 'Serial / IMEI',
    password: '设备密码',
    matKhau: '设备密码',
    qty: '数量',
    returnDate: '归还日期',
    lineNote: '行备注',
    retailCustomer: '零售客户',
    discount: '优惠',
    customerPaid: '客户已付',
    totalGoods: '货品总额',
    customerMustPay: '客户应付',
    stillOwed: '尚欠',
    // POS-only fields (layout 1.PNG)
    customerSearch: '查找客户 (F4)',
    serialImei: 'Serial/IMEI/车牌号',
    model: '型号',
    modelPlaceholder: '输入机器型号',
    returnDatePos: '归还客户',
    ngayNhan: '接收日期',
    ngayTra: '归还日期',
    nguoiNhanTra: '领回人',
    ngayBaoLoi: '报修日期',
    noiDungBaoLoi: '报修内容',
    ngayLenHoaDonLinhKien: '配件开票',
    ngayCoLinhKien: '配件到货',
    ketQuaChotKhach: '客户确认结果',
    lyDoKetThuc: '结束原因',
    lyDoKetThucHint: '仅设备已完成后可选 — 留空将按客户确认结果自动推断',
    ngayTraHang: '归还日期',
    nguoiNhanTraHang: '领回人',
    trangThai: '状态',
    loaiYeuCau: '请求类型',
    tongPhi: '总费用',
    soLuong: '数量',
    kyThuatVien: '技师',
    ghiChuDon: '订单备注',
    ghiChuDichVu: '配件 / 服务备注',
    notePlaceholder: '备注',
    chonKyThuat: '--- 选择 ---',
    bangGiaDefault: '通用价格表',
    pickDichVu: '搜索更换配件',
    emptyDichVuHint: '暂无服务 — 请在上方搜索添加',
    sectionThietBi: '设备',
    sectionXuLy: '处理',
    itemExpand: '展开',
    itemCollapse: '收起',
    sectionBaoLoi: '故障与结论',
    sectionLinhKien: '配件与退还',
    noiDungBaoLoiPlaceholder: '描述客户反馈的故障…',
    sectionDichVu: '更换配件',
    maHangCol: '货号',
    tenHangCol: '品名',
    ghiChuCol: '备注',
    hinhAnhToggle: '添加设备照片',
    hinhAnhCount: '{n} 张照片',
    dichVuCount: '{n} 行',
    customerPayment: '客户支付',
    paymentMethod: '支付方式',
    paymentCash: '现金',
    paymentTransfer: '转账',
    paymentCard: '银行卡',
    paymentWallet: '电子钱包',
    tienThua: '找零',
    conCanTra: '尚欠',
    thuKhac: '其他费用',
    donVi: '单位',
    donGia: '单价',
    giaBan: '售价',
    editPrice: '编辑售价',
    discountPercent: '折扣 (%)',
    byAmount: '按金额',
    byPercent: '按 %',
    priceBelowCost: '售价低于成本价',
    discountCellHint: '输入金额，或加 % 按百分比优惠（例如 10%）',
    dichVuColumnSettings: '显示 / 隐藏列',
    dichVuColumnReset: '恢复默认',
    dichVuColumnLocked: '必填列，不能隐藏',
    thanhTien: '小计',
    dichVuHangHoa: '更换配件',
    modelEmpty: '待修设备',
    hangHoaEmpty: '维修货品',
    hangHoaEmptyHint: '请使用上方搜索框（F3）添加需维修货品。',
    pickHangHoaSua: '查找商品 (F3)',
    addHangHoa: '新增商品',
    addDichVu: '添加服务',
    noiTiepNhanLabel: '到店',
    save: '保存',
    taoHoaDon: '创建发票',
    hinhAnhHang: '维修货品照片',
    hinhAnhAdd: '添加照片',
    hinhAnhPaste: '粘贴照片',
    hinhAnhUploading: '正在上传照片',
    hinhAnhSetMain: '设为主图',
    hinhAnhMain: '主',
    hinhAnhHint: '最多 5 张照片（第一张为主图）。',
    hinhAnhDragDrop: '将照片拖放到此处',
  },
  fields: {
    totalAmount: '总额',
    totalGoods: '货品总额',
    discount: '优惠',
    customerMustPay: '客户应付',
    customerPaid: '客户已付',
    stillOwed: '尚欠',
  },
  messages: {
    loadError: '加载失败。',
    deleteSuccess: '已删除。',
    createSuccess: '已创建维修请求。',
    updateSuccess: '已更新维修请求。',
    needLines: '请至少添加一行维修货品。',
    soLuongThietBiMin: '接收设备数量必须至少为 1。',
    traTatCaChuaXong: '仍有设备未完成维修，无法全部归还。',
    traTatCaCanNguoiNhan: '请选择归还接收人。',
    noData: '暂无数据。',
    noLines: '暂无行。',
    noServices: '暂无维修服务。',
    listSummary: '共 {count} 条',
    processSuccess: '已开始处理请求。',
    taoHoaDonSuccess: '已根据维修请求创建发票。',
    taoHoaDonError: '创建发票失败。',
    phieuXuatKhoFromRepair: '按维修单 {code} 销售出库',
    completeSuccess: '已完成维修请求。',
    cancelSuccess: '已取消维修请求。',
    exportSuccess: '已导出文件。',
    exportError: '导出失败。',
    printSuccess: '已发送打印请求。',
    confirmCancel: '确认取消该请求？',
    confirmComplete: '确认完成该请求？',
    confirmTraHang: '确认归还客户？',
    traHangSuccess: '已归还客户。',
    confirmTraHangRows: '归还 {n} 台未归还设备给客户？',
    traHangCanhBaoChuaXong: '{n} 台设备尚未修好仍将被归还。',
    traHangChuaXong: '设备尚未修好，仍要归还客户？',
    traHangGiaTriCu: '当前：{ngay} · {nguoi}',
    traHangOverwriteConfirm: '将覆盖原归还记录 — 操作将记录审计日志（旧 → 新）。是否继续？',
    traHangXacNhanGhiDe: '确认覆盖',
    traHangDaTra: '已归还',
    traHangThietBi: '归还设备',
    xoaNgayTraPhieuCanhBao: '删除单据归还日期将同时删除全部设备的归还日期。是否继续？',
    hinhAnhUploadError: '上传照片失败。',
  },
  actions: {
    process: '处理',
    complete: '完成',
    cancelVoucher: '取消',
    export: '导出',
    print: '打印',
    save: '保存',
    taoPhieuXuatKho: '创建出库单',
    traHang: '归还',
    traTatCa: '全部归还',
    suaThongTinTra: '编辑归还信息',
  },
  placeholders: {
    formTitle: '创建/编辑维修请求',
    formBody: '完整表单将后续补充。',
  },
  pos: {
    addTab: '添加维修请求标签',
    tabTitle: '维修 {n}',
    tabEdit: '编辑 {code}',
    tabClone: '复制 {code}',
    history: '维修请求历史',
    confirmCloseTitle: '关闭此标签?',
    confirmCloseBody: '该标签有未保存的更改。关闭后将丢失未保存的更改。',
    newTabYeuCauSuaChua: '新建维修请求',
    openEdit: '打开编辑标签',
    openClone: '复制',
    saved: '已保存维修请求。',
    status: '状态',
    statusAll: '全部',
    statusYeuCauSuaChua: '维修请求',
  },
  giaiDoan: {
    tatCa: '全部（不含已取消）',
    chuaXong: '未完成',
    choKhachChot: '待客户确认',
    dangSua: '维修中',
    khongSuaChoDong: '客户拒修，未关闭',
    daXong: '已完成',
    choTraKhach: '已修好，待归还',
    daTra: '已归还客户',
    chuaTra: '未归还',
    quaHan: '逾期未还',
  },
  baoCao: {
    thoiGian: '时间（单据创建日）',
    duAn: '项目',
    duAnHienTai: '当前',
    kyThuatVien: '技术员',
    tatCaKtv: '全部技术员',
    khongCoKtv: '未找到技术员',
    chuaPhanCong: '未分配',
    bieuDoTheo: '图表按',
    ngay: '日',
    tuan: '周',
    thang: '月',
    kyTuan: '{y}年第{w}周',
    kyThang: '{y}年{m}月',
    kyNam: '{y}年',
    tyLeXong: '完成率',
    tyLeTra: '归还率',
    tyLeXongLine: '完成率',
    chartKtv: '技术员工作量',
    chartKtvHint: '按维修状态统计已分配产品',
    chartKtvTop: '按产品数前 {n} 名',
    chartKtvChuaPhanCong: '{n} 个未分配产品',
    phamVi: '{tu} – {den} · {n} 个项目',
    lamMoi: '刷新',
    thuLai: '重试',
    loadError: '无法加载报表。',
    empty: '该期间没有维修请求。',
    moDanhSach: '点击打开设备列表',
    phieuSuaXongChuaTra: '未全部归还',
    phieuSuaXongChuaTraHint: '该单据仍有至少一台设备未归还',
    khacDuAnHint: '正在查看多个项目：仅当前项目的数据可打开列表。',
    tongDon: '维修单总数',
    tongSp: '维修产品总数',
    daXong: '已完成',
    chuaXong: '未完成',
    daTraKhach: '已归还',
    chuaTraKhach: '未归还',
    choTraKhach: '已修好，待归还',
    nhomSuaChua: '维修',
    nhomTraKhach: '归还',
    kpiTongDonSub: '未取消 · {n} 个项目',
    kpiTongSpSub: '平均每单 {n} 件',
    kpiPctSub: '占产品 {pct}',
    kpiTreHenSub: '{n} 件逾期',
    kpiKhongTreHen: '无逾期',
    kpiChuaTraSub: '含 {n} 件已修好待取',
    bangTongHop: '汇总',
    bangKtvThang: '技术员按月',
    bangTheoLoai: '按请求类型',
    chiTietKtv: '按技术员明细',
    duAnCot: '项目',
    nam: '年',
    thangCot: '月',
    caThang: '整月',
    congDuAn: '{ten} 合计',
    tongCong: '总计',
    congTong: '合计',
    tong: '合计',
    chiSo: '指标：',
    loaiYeuCau: '请求类型',
    chuaPhanLoai: '未分类',
    chartTienDo: '按接收期间的进度',
    chartTienDoHint: '各期间接收的产品当前所处阶段',
    chartKetQua: '处理结果',
    chartKetQuaHint: '已完成产品按结束原因',
    chartKetQuaEmpty: '暂无已完成产品',
    ketQua: {
      suaXong: '已修好',
      khachKhongSua: '客户不修',
      khongCoLinhKien: '无配件',
      khongThayLoi: '未发现故障',
      chuaRoLyDo: '未记录原因',
    },
  },
}
